import { call, put, takeEvery, delay } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import  CourseHelper  from '../../../../utils/API/BackendHelper/admin/course';
import ApiHelper from '../../../../utils/MUX/ApiHelper';
// Course Category Sagas
function* fetchCourseCategoriesSaga(action) {
  try {
    const params = action.payload || {};
    const response = yield call(CourseHelper.getAllCategories, params);

    console.log('Fetch categories response:', response);

    if (response.success) {
      yield put(actions.fetchCourseCategoriesSuccess(response.data));
    } else {
      yield put(actions.fetchCourseCategoriesFailure(response.message || 'Failed to fetch course categories'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchCourseCategoriesSaga:', error);
    yield put(actions.fetchCourseCategoriesFailure(error.message || 'An unexpected error occurred'));
  }
}

function* createCourseCategorySaga(action) {
  try {
    const categoryData = action.payload;
    const response = yield call(CourseHelper.createCategory, categoryData);

    console.log('Create category response:', response);

    if (response.success) {
      const newCategory = response.data;
      yield put(actions.createCourseCategorySuccess(newCategory));
      
      // Add delay to show success message
      yield delay(1500);
      
      // Trigger navigation
      yield put({ type: 'NAVIGATE_TO_COURSE_CATEGORIES' });
    } else {
      yield put(actions.createCourseCategoryFailure(response.message || 'Failed to create course category'));
    }
  } catch (error) {
    console.error('Unexpected error in createCourseCategorySaga:', error);
    yield put(actions.createCourseCategoryFailure(error.message || 'An unexpected error occurred'));
  }
}

function* updateCourseCategorySaga(action) {
  try {
    const { categoryId, updateData } = action.payload;
    const response = yield call(CourseHelper.updateCategory, categoryId, updateData);

    if (response.success) {
      yield put(actions.updateCourseCategorySuccess(response.data));
    } else {
      yield put(actions.updateCourseCategoryFailure(response.message || 'Failed to update course category'));
    }
  } catch (error) {
    console.error('Unexpected error in updateCourseCategorySaga:', error);
    yield put(actions.updateCourseCategoryFailure(error.message || 'An unexpected error occurred'));
  }
}

function* deleteCourseCategorySaga(action) {
  try {
    const categoryId = action.payload;
    const response = yield call(CourseHelper.deleteCategory, categoryId);

    if (response.success) {
      yield put(actions.deleteCourseCategorySuccess(categoryId));
    } else {
      yield put(actions.deleteCourseCategoryFailure(response.message || 'Failed to delete course category'));
    }
  } catch (error) {
    console.error('Unexpected error in deleteCourseCategorySaga:', error);
    yield put(actions.deleteCourseCategoryFailure(error.message || 'An unexpected error occurred'));
  }
}

function* getCourseCategoryByIdSaga(action) {
  try {
    const categoryId = action.payload;
    const response = yield call(CourseHelper.getCategoryById, categoryId);

    if (response.success) {
      yield put(actions.getCourseCategoryByIdSuccess(response.data));
    } else {
      yield put(actions.getCourseCategoryByIdFailure(response.message || 'Failed to fetch course category'));
    }
  } catch (error) {
    console.error('Unexpected error in getCourseCategoryByIdSaga:', error);
    yield put(actions.getCourseCategoryByIdFailure(error.message || 'An unexpected error occurred'));
  }
}

// Course Sagas
function* fetchCoursesSaga(action) {
  try {
    const params = action.payload || {};
    const response = yield call(CourseHelper.getAllCourses, params);

    console.log('Fetch courses response:', response);

    if (response.success) {
      yield put(actions.fetchCoursesSuccess(response.data));
    } else {
      yield put(actions.fetchCoursesFailure(response.message || 'Failed to fetch courses'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchCoursesSaga:', error);
    yield put(actions.fetchCoursesFailure(error.message || 'An unexpected error occurred'));
  }
}

function* createCourseSaga(action) {
  try {
    const courseData = action.payload;
    const response = yield call(CourseHelper.createCourse, courseData);

    console.log('Create course response:', response);

    if (response.success) {
      const newCourse = response.data;
      yield put(actions.createCourseSuccess(newCourse));
      
      // Add delay to show success message
      yield delay(1500);
      
      // Trigger navigation
      yield put({ type: 'NAVIGATE_TO_COURSES' });
    } else {
      yield put(actions.createCourseFailure(response.message || 'Failed to create course'));
    }
  } catch (error) {
    console.error('Unexpected error in createCourseSaga:', error);
    yield put(actions.createCourseFailure(error.message || 'An unexpected error occurred'));
  }
}

function* updateCourseSaga(action) {
  try {
    const { courseId, updateData } = action.payload;
    const response = yield call(CourseHelper.updateCourse, courseId, updateData);

    console.log('Update course response:', response);

    if (response.success) {
      yield put(actions.updateCourseSuccess(response.data));
      
      // Optional: Show success message
      // You can add a toast notification here
      
    } else {
      yield put(actions.updateCourseFailure(response.message || 'Failed to update course'));
    }
  } catch (error) {
    console.error('Unexpected error in updateCourseSaga:', error);
    yield put(actions.updateCourseFailure(error.message || 'An unexpected error occurred'));
  }
}

function* deleteCourseSaga(action) {
  try {
    const courseId = action.payload;
    const response = yield call(CourseHelper.deleteCourse, courseId);

    console.log('Delete course response:', response);

    if (response.success) {
      yield put(actions.deleteCourseSuccess(courseId));
      
      // Optional: Show success message
      // You can add a toast notification here
      
    } else {
      yield put(actions.deleteCourseFailure(response.message || 'Failed to delete course'));
    }
  } catch (error) {
    console.error('Unexpected error in deleteCourseSaga:', error);
    yield put(actions.deleteCourseFailure(error.message || 'An unexpected error occurred'));
  }
}

function* getCourseByIdSaga(action) {
  try {
    const courseId = action.payload;
    const response = yield call(CourseHelper.getCourseById, courseId);

    if (response.success) {
      yield put(actions.getCourseByIdSuccess(response.data));
    } else {
      yield put(actions.getCourseByIdFailure(response.message || 'Failed to fetch course'));
    }
  } catch (error) {
    console.error('Unexpected error in getCourseByIdSaga:', error);
    yield put(actions.getCourseByIdFailure(error.message || 'An unexpected error occurred'));
  }
}

// SME Assignment Sagas
function* assignSMEToCourseSaga(action) {
  try {
    const { courseId, smeId } = action.payload;
    const response = yield call(CourseHelper.assignSMEToCourse, courseId, smeId);

    if (response.success) {
      yield put(actions.assignSMEToCourseSuccess(courseId, response.data));
    } else {
      yield put(actions.assignSMEToCourseFailure(response.message || 'Failed to assign SME to course', courseId));
    }
  } catch (error) {
    console.error('Unexpected error in assignSMEToCourseSaga:', error);
    yield put(actions.assignSMEToCourseFailure(error.message || 'An unexpected error occurred', action.payload.courseId));
  }
}

function* unassignSMEFromCourseSaga(action) {
  try {
    const { courseId, smeId } = action.payload;
    const response = yield call(CourseHelper.unassignSMEFromCourse, courseId, smeId);

    if (response.success) {
      yield put(actions.unassignSMEFromCourseSuccess(courseId, smeId));
    } else {
      yield put(actions.unassignSMEFromCourseFailure(response.message || 'Failed to unassign SME from course', courseId));
    }
  } catch (error) {
    console.error('Unexpected error in unassignSMEFromCourseSaga:', error);
    yield put(actions.unassignSMEFromCourseFailure(error.message || 'An unexpected error occurred', action.payload.courseId));
  }
}

function* getCourseSMEsSaga(action) {
  try {
    const courseId = action.payload;
    const response = yield call(CourseHelper.getCourseSMEs, courseId);

    if (response.success) {
      yield put(actions.getCourseSMEsSuccess(courseId, response.data));
    } else {
      yield put(actions.getCourseSMEsFailure(response.message || 'Failed to fetch course SMEs'));
    }
  } catch (error) {
    console.error('Unexpected error in getCourseSMEsSaga:', error);
    yield put(actions.getCourseSMEsFailure(error.message || 'An unexpected error occurred'));
  }
}

// Upload video file to Mux


function* adminCourseSaga() {
  // Category sagas
  yield takeEvery(types.FETCH_COURSE_CATEGORIES_REQUEST, fetchCourseCategoriesSaga);
  yield takeEvery(types.CREATE_COURSE_CATEGORY_REQUEST, createCourseCategorySaga);
  yield takeEvery(types.UPDATE_COURSE_CATEGORY_REQUEST, updateCourseCategorySaga);
  yield takeEvery(types.DELETE_COURSE_CATEGORY_REQUEST, deleteCourseCategorySaga);
  yield takeEvery(types.GET_COURSE_CATEGORY_BY_ID_REQUEST, getCourseCategoryByIdSaga);
  
  // Course sagas
  yield takeEvery(types.FETCH_COURSES_REQUEST, fetchCoursesSaga);
  yield takeEvery(types.CREATE_COURSE_REQUEST, createCourseSaga);
  yield takeEvery(types.UPDATE_COURSE_REQUEST, updateCourseSaga);
  yield takeEvery(types.DELETE_COURSE_REQUEST, deleteCourseSaga);
  yield takeEvery(types.GET_COURSE_BY_ID_REQUEST, getCourseByIdSaga);
  
  // SME assignment sagas
  yield takeEvery(types.ASSIGN_SME_TO_COURSE_REQUEST, assignSMEToCourseSaga);
  yield takeEvery(types.UNASSIGN_SME_FROM_COURSE_REQUEST, unassignSMEFromCourseSaga);
  yield takeEvery(types.GET_COURSE_SMES_REQUEST, getCourseSMEsSaga);

  // Mux video upload saga


}

export default adminCourseSaga;